/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type DayTimeSlotInput = {
    date: string;
    timeSlot: TimeSlot;
};
export type TeamHealthDashboardRendererQueryVariables = {
    timeZone: string;
    rangeMin: DayTimeSlotInput;
    rangeMax: DayTimeSlotInput;
    teamId: string;
    hasTeams: boolean;
};
export type TeamHealthDashboardRendererQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly " $fragmentRefs": FragmentRefs<"TeamHealthDashboard_org">;
                    } | null;
                } | null> | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"TeamHealthDashboard_user">;
        } | null;
    };
};
export type TeamHealthDashboardRendererQuery = {
    readonly response: TeamHealthDashboardRendererQueryResponse;
    readonly variables: TeamHealthDashboardRendererQueryVariables;
};



/*
query TeamHealthDashboardRendererQuery(
  $timeZone: String!
  $rangeMin: DayTimeSlotInput!
  $rangeMax: DayTimeSlotInput!
  $teamId: String!
  $hasTeams: Boolean!
) {
  viewer {
    user {
      ...TeamHealthDashboard_user
      orgs(first: 1000000) {
        edges {
          node {
            ...TeamHealthDashboard_org_1YFfcm
            id
          }
        }
      }
      id
    }
    id
  }
}

fragment CalendarStatus_calendarStatus on CalendarStatus {
  status
  moonPhase
}

fragment CalendarStatus_person on Person {
  profile {
    givenName
  }
}

fragment CalendarStatus_profileTimeZone on ProfileTimeZone {
  timeZone
  userId
  calendarId
}

fragment CalendarTimeZone_person on Person {
  profile {
    givenName
  }
}

fragment CalendarTimeZone_profileTimeZone on ProfileTimeZone {
  timeZone
  userId
  calendarId
}

fragment TeamHealthDashboard_org_1YFfcm on Org {
  ...TeammateAnalyticsCard_org
  id
  experiments
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      ...TeamPickerWithActions_userTeams
      list {
        teamId
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  teamHealthScoreForTeamErrorable(timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax, teamId: $teamId) @include(if: $hasTeams) {
    __typename
    ... on GraphEntityError {
      statusCode
    }
    ... on TeamHealthScore {
      myFocusTimeScore {
        calendarId
        totalMinutes
        ...TeammateAnalyticsCard_calendarFocusTimeScore
      }
      calendarFocusTimeScores {
        calendarId
        totalMinutes
        ...TeammateAnalyticsCard_calendarFocusTimeScore
      }
      profileTimeZones {
        calendarId
        ...TeammateAnalyticsCard_profileTimeZone
        ...TeammateAnalyticsCard_currentUserTimeZone
      }
      persons {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on PersonList {
          list {
            ...TeammateAnalyticsCard_person
            primaryEmail
            emails
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            id
          }
        }
      }
      orgPersons {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on OrgPersonList {
          list {
            ...TeammateAnalyticsCard_orgPerson
            primaryCalendarId
            calendarAliases
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            id
          }
        }
      }
    }
  }
  teamHealthScoreJustForUserErrorable(timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {
    __typename
    ... on GraphEntityError {
      statusCode
    }
    ... on TeamHealthScore {
      myFocusTimeScore {
        calendarId
        totalMinutes
        ...TeammateAnalyticsCard_calendarFocusTimeScore
      }
      calendarFocusTimeScores {
        calendarId
        totalMinutes
        ...TeammateAnalyticsCard_calendarFocusTimeScore
      }
      profileTimeZones {
        calendarId
        ...TeammateAnalyticsCard_profileTimeZone
        ...TeammateAnalyticsCard_currentUserTimeZone
      }
      persons {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on PersonList {
          list {
            ...TeammateAnalyticsCard_person
            primaryEmail
            emails
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
            id
          }
        }
      }
    }
  }
  teamCalendarStatusErrorable(timeZone: $timeZone) {
    __typename
    ... on CalendarStatusList {
      list {
        calendarId
        ...TeammateAnalyticsCard_calendarStatus
        id
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment TeamHealthDashboard_user on User {
  id
}

fragment TeamPickerWithActions_userTeams on TeamList {
  list {
    teamId
    teamName
    id
  }
}

fragment TeammateAnalyticsCard_calendarFocusTimeScore on CalendarFocusTimeScore {
  ...TeammateHealthAvatar_calendarFocusTimeScore
  calendarId
  busyMinutes
  focusMinutes
  totalMinutes
  crawledStatus
}

fragment TeammateAnalyticsCard_calendarStatus on CalendarStatus {
  ...CalendarStatus_calendarStatus
}

fragment TeammateAnalyticsCard_currentUserTimeZone on ProfileTimeZone {
  timeZone
}

fragment TeammateAnalyticsCard_org on Org {
  id
  experiments
  ...TeammateHealthAvatar_org
}

fragment TeammateAnalyticsCard_orgPerson on OrgPerson {
  userId
  personId
  primaryCalendarId
  profile {
    givenName
    familyName
    externalImageUrl
  }
  isYou
}

fragment TeammateAnalyticsCard_person on Person {
  ...CalendarStatus_person
  ...CalendarTimeZone_person
  ...TeammateHealthAvatar_person
  isUser
  primaryEmail
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment TeammateAnalyticsCard_profileTimeZone on ProfileTimeZone {
  timeZone
  ...CalendarStatus_profileTimeZone
  ...CalendarTimeZone_profileTimeZone
}

fragment TeammateHealthAvatar_calendarFocusTimeScore on CalendarFocusTimeScore {
  calendarId
  busyMinutes
  focusMinutes
  totalMinutes
  crawledStatus
}

fragment TeammateHealthAvatar_org on Org {
  id
  experiments
}

fragment TeammateHealthAvatar_person on Person {
  __typename
  id
  emails
  primaryEmail
  isYou
  userId
  isUser
  profile {
    givenName
    familyName
    externalImageUrl
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasTeams"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMax"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rangeMin"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "timeZone"
    } as any, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v6 = {
        "kind": "Variable",
        "name": "rangeMax",
        "variableName": "rangeMax"
    } as any, v7 = {
        "kind": "Variable",
        "name": "rangeMin",
        "variableName": "rangeMin"
    } as any, v8 = {
        "kind": "Variable",
        "name": "teamId",
        "variableName": "teamId"
    } as any, v9 = {
        "kind": "Variable",
        "name": "timeZone",
        "variableName": "timeZone"
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v16 = {
        "kind": "InlineFragment",
        "selections": [
            (v14 /*: any*/),
            (v15 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v17 = {
        "kind": "InlineFragment",
        "selections": [
            (v14 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any, v19 = [
        (v18 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "busyMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "focusMinutes",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "crawledStatus",
            "storageKey": null
        } as any
    ], v20 = {
        "alias": null,
        "args": null,
        "concreteType": "CalendarFocusTimeScore",
        "kind": "LinkedField",
        "name": "myFocusTimeScore",
        "plural": false,
        "selections": (v19 /*: any*/),
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "concreteType": "CalendarFocusTimeScore",
        "kind": "LinkedField",
        "name": "calendarFocusTimeScores",
        "plural": true,
        "selections": (v19 /*: any*/),
        "storageKey": null
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "concreteType": "ProfileTimeZone",
        "kind": "LinkedField",
        "name": "profileTimeZones",
        "plural": true,
        "selections": [
            (v18 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeZone",
                "storageKey": null
            },
            (v22 /*: any*/)
        ],
        "storageKey": null
    } as any, v24 = {
        "kind": "InlineFragment",
        "selections": [
            (v15 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "persons",
        "plural": false,
        "selections": [
            (v11 /*: any*/),
            (v24 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                            (v25 /*: any*/),
                            (v11 /*: any*/),
                            (v10 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "emails",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "primaryEmail",
                                "storageKey": null
                            },
                            (v26 /*: any*/),
                            (v22 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUser",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "PersonList",
                "abstractKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "TeamHealthDashboardRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "hasTeams",
                                                                    "variableName": "hasTeams"
                                                                },
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamHealthDashboard_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TeamHealthDashboard_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v2 /*: any*/),
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "TeamHealthDashboardRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v10 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v12 /*: any*/),
                                                                        (v13 /*: any*/)
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v16 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v10 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Team",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v12 /*: any*/),
                                                                                (v13 /*: any*/),
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamList",
                                                                    "abstractKey": null
                                                                },
                                                                (v16 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v6 /*: any*/),
                                                                (v7 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "teamHealthScoreJustForUserErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                (v17 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v20 /*: any*/),
                                                                        (v21 /*: any*/),
                                                                        (v23 /*: any*/),
                                                                        (v27 /*: any*/)
                                                                    ],
                                                                    "type": "TeamHealthScore",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                (v9 /*: any*/)
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "teamCalendarStatusErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v11 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "CalendarStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v18 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "status",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "moonPhase",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "CalendarStatusList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v15 /*: any*/),
                                                                        (v14 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "condition": "hasTeams",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": [
                                                                        (v6 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/),
                                                                        (v9 /*: any*/)
                                                                    ],
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "teamHealthScoreForTeamErrorable",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v11 /*: any*/),
                                                                        (v17 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v20 /*: any*/),
                                                                                (v21 /*: any*/),
                                                                                (v23 /*: any*/),
                                                                                (v27 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "orgPersons",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v11 /*: any*/),
                                                                                        (v24 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "OrgPerson",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "list",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        (v22 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "personId",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "primaryCalendarId",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v25 /*: any*/),
                                                                                                        (v26 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "calendarAliases",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v10 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "OrgPersonList",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "TeamHealthScore",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        (v10 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b32c271c9e4a499245a98bceb837fdf9",
            "id": null,
            "metadata": {},
            "name": "TeamHealthDashboardRendererQuery",
            "operationKind": "query",
            "text": "query TeamHealthDashboardRendererQuery(\n  $timeZone: String!\n  $rangeMin: DayTimeSlotInput!\n  $rangeMax: DayTimeSlotInput!\n  $teamId: String!\n  $hasTeams: Boolean!\n) {\n  viewer {\n    user {\n      ...TeamHealthDashboard_user\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...TeamHealthDashboard_org_1YFfcm\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment CalendarStatus_calendarStatus on CalendarStatus {\n  status\n  moonPhase\n}\n\nfragment CalendarStatus_person on Person {\n  profile {\n    givenName\n  }\n}\n\nfragment CalendarStatus_profileTimeZone on ProfileTimeZone {\n  timeZone\n  userId\n  calendarId\n}\n\nfragment CalendarTimeZone_person on Person {\n  profile {\n    givenName\n  }\n}\n\nfragment CalendarTimeZone_profileTimeZone on ProfileTimeZone {\n  timeZone\n  userId\n  calendarId\n}\n\nfragment TeamHealthDashboard_org_1YFfcm on Org {\n  ...TeammateAnalyticsCard_org\n  id\n  experiments\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      ...TeamPickerWithActions_userTeams\n      list {\n        teamId\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  teamHealthScoreForTeamErrorable(timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax, teamId: $teamId) @include(if: $hasTeams) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n    }\n    ... on TeamHealthScore {\n      myFocusTimeScore {\n        calendarId\n        totalMinutes\n        ...TeammateAnalyticsCard_calendarFocusTimeScore\n      }\n      calendarFocusTimeScores {\n        calendarId\n        totalMinutes\n        ...TeammateAnalyticsCard_calendarFocusTimeScore\n      }\n      profileTimeZones {\n        calendarId\n        ...TeammateAnalyticsCard_profileTimeZone\n        ...TeammateAnalyticsCard_currentUserTimeZone\n      }\n      persons {\n        __typename\n        ... on GraphEntityError {\n          message\n        }\n        ... on PersonList {\n          list {\n            ...TeammateAnalyticsCard_person\n            primaryEmail\n            emails\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            isYou\n            id\n          }\n        }\n      }\n      orgPersons {\n        __typename\n        ... on GraphEntityError {\n          message\n        }\n        ... on OrgPersonList {\n          list {\n            ...TeammateAnalyticsCard_orgPerson\n            primaryCalendarId\n            calendarAliases\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            isYou\n            id\n          }\n        }\n      }\n    }\n  }\n  teamHealthScoreJustForUserErrorable(timeZone: $timeZone, rangeMin: $rangeMin, rangeMax: $rangeMax) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n    }\n    ... on TeamHealthScore {\n      myFocusTimeScore {\n        calendarId\n        totalMinutes\n        ...TeammateAnalyticsCard_calendarFocusTimeScore\n      }\n      calendarFocusTimeScores {\n        calendarId\n        totalMinutes\n        ...TeammateAnalyticsCard_calendarFocusTimeScore\n      }\n      profileTimeZones {\n        calendarId\n        ...TeammateAnalyticsCard_profileTimeZone\n        ...TeammateAnalyticsCard_currentUserTimeZone\n      }\n      persons {\n        __typename\n        ... on GraphEntityError {\n          message\n        }\n        ... on PersonList {\n          list {\n            ...TeammateAnalyticsCard_person\n            primaryEmail\n            emails\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            isYou\n            id\n          }\n        }\n      }\n    }\n  }\n  teamCalendarStatusErrorable(timeZone: $timeZone) {\n    __typename\n    ... on CalendarStatusList {\n      list {\n        calendarId\n        ...TeammateAnalyticsCard_calendarStatus\n        id\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment TeamHealthDashboard_user on User {\n  id\n}\n\nfragment TeamPickerWithActions_userTeams on TeamList {\n  list {\n    teamId\n    teamName\n    id\n  }\n}\n\nfragment TeammateAnalyticsCard_calendarFocusTimeScore on CalendarFocusTimeScore {\n  ...TeammateHealthAvatar_calendarFocusTimeScore\n  calendarId\n  busyMinutes\n  focusMinutes\n  totalMinutes\n  crawledStatus\n}\n\nfragment TeammateAnalyticsCard_calendarStatus on CalendarStatus {\n  ...CalendarStatus_calendarStatus\n}\n\nfragment TeammateAnalyticsCard_currentUserTimeZone on ProfileTimeZone {\n  timeZone\n}\n\nfragment TeammateAnalyticsCard_org on Org {\n  id\n  experiments\n  ...TeammateHealthAvatar_org\n}\n\nfragment TeammateAnalyticsCard_orgPerson on OrgPerson {\n  userId\n  personId\n  primaryCalendarId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n  isYou\n}\n\nfragment TeammateAnalyticsCard_person on Person {\n  ...CalendarStatus_person\n  ...CalendarTimeZone_person\n  ...TeammateHealthAvatar_person\n  isUser\n  primaryEmail\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment TeammateAnalyticsCard_profileTimeZone on ProfileTimeZone {\n  timeZone\n  ...CalendarStatus_profileTimeZone\n  ...CalendarTimeZone_profileTimeZone\n}\n\nfragment TeammateHealthAvatar_calendarFocusTimeScore on CalendarFocusTimeScore {\n  calendarId\n  busyMinutes\n  focusMinutes\n  totalMinutes\n  crawledStatus\n}\n\nfragment TeammateHealthAvatar_org on Org {\n  id\n  experiments\n}\n\nfragment TeammateHealthAvatar_person on Person {\n  __typename\n  id\n  emails\n  primaryEmail\n  isYou\n  userId\n  isUser\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2c02d0fbb2fb0f5e03410c163d5f6fe0';
export default node;
